import CssBaseline from "@mui/material/CssBaseline";
import { Box } from "@mui/material";
import Container from "@mui/material/Container";
import SignInCard from "@components/SignInCard";
import Content from "@components/Content";
import Grid from "@mui/material/Grid2";

export default function SignInSide() {
  return (
    <>
      <CssBaseline enableColorScheme />
      <Box
        component="main"
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          overflow: "hidden",
          background: (theme) => ({
            backgroundImage:
              "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
            ...theme.applyStyles("dark", {
              backgroundImage:
                "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
            }),
          }),
        }}
      >
        <Container
          maxWidth="xl"
          sx={{
            height: "100%",
            px: { xs: 2, sm: 3, md: 4, lg: 6 },
            py: { xs: 2, sm: 3 },
          }}
        >
          <Grid
            container
            spacing={{ xs: 2, sm: 3, md: 4 }}
            alignItems="center"
            justifyContent="center"
            sx={{
              height: "100%",
            }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
                pr: { md: 2, lg: 3 },
              }}
            >
              <Content />
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                pl: { md: 2, lg: 3 },
              }}
            >
              <Box sx={{ width: "100%", maxWidth: 480 }}>
                <SignInCard />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}
